<template>
  <div class="c-message-at-item">
    <Avatar :user="comment.sender" />
    <main>
      <div class="sender-info">
        <span>
          <RouterLink
            class="username"
            :to="`/users/${comment.sender.id}`"
          >
            {{ comment.sender&&comment.sender.name }}
          </RouterLink>
          <span style="color:#999">{{ $t('message.at.ated') }}</span>
        </span>
      </div>
      <div v-if="isComments" class="time">{{ commentInfo.created_at | time2tips }}</div>
      <Component
        :is="componentMap[commentInfo.resourceable.type]"
        v-if="isComments"
        :id="commentInfo.resourceable.id"
        v-slot="{time}"
        :message="comment"
        class="component"
      >
        <div v-if="time" class="time">{{ time | time2tips }}</div>
      </Component>
      <Component
        :is="componentMap[type]"
        v-else-if="type"
        :id="comment.resource.id"
        v-slot="{time}"
        :message="comment"
        class="component"
      >
        <div v-if="time" class="time">{{ time | time2tips }}</div>
      </Component>
    </main>
  </div>
</template>

<script>
  import ReferenceFeed from '@/components/reference/ReferenceFeed.vue'
  import ReferenceNews from '@/components/reference/ReferenceNews.vue'
  import ReferencePost from '@/components/reference/ReferencePost.vue'
  import ReferenceAnswer from '@/components/reference/ReferenceAnswer.vue'
  import ReferenceQuestion from '@/components/reference/ReferenceQuestion.vue'

  import { getComment } from '@/api/bootstrappers'

  const componentMap = {
    'feeds': ReferenceFeed,
    'news': ReferenceNews,
    'group-posts': ReferencePost,
    'questions': ReferenceQuestion,
    'question-answers': ReferenceAnswer,
  }
  // import ReferenceNews from '@/components/reference/ReferenceNews';
  // import MessageCommentsItem from './MessageCommentsItem.vue'

  export default {
    name: 'MessageAtItem',
    components: {
      ReferenceFeed,
      ReferenceNews,
      ReferencePost,
      ReferenceAnswer,
      ReferenceQuestion,
    },
    props: {
      comment: { type: Object, required: true, default: () => {} },
    },
    data () {
      return {
        commentInfo: { resourceable: {} },
        componentMap,
      }
    },
    computed: {
      isComments () {
        const { resource = { type: '' } } = this.comment || {}
        return resource.type === 'comments'
      },
      type () {
        const { resource = { type: '' } } = this.comment || {}
        return resource.type
      },
    },
    created () {
      this.fetchComment()
    },
    methods: {
      async fetchComment () {
        if (this.isComments) {
          const { data } = await getComment({ id: this.comment.resource.id })
          this.commentInfo = data[0]
          console.log('data', data[0])
        }
      },
    },

  }
</script>

<style lang="less" scoped>
.c-message-at-item {
  display: flex;

  .m-avatar-box {
    margin-right: 15px;
  }

  > main {
    flex: auto;
  }

  .sender-info {
    flex: auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 4px;

    .user-info {
      font-size: 28px;
      color: #999;
    }

    .reply {
      flex: none;
      font-size: 26px;
      color: #999;
    }
  }

    .time {
      font-size: 26px;
      color: #ccc;
      margin-bottom: 20px;
    }
}
</style>

<style scoped>
.component >>> .time {
   font-size: 26px;
    color: #ccc;
    margin-bottom: 20px;

}
</style>
